<div class="prompt-actions">
  <button
    type="button"
    class="prompt-action improve"
    (click)="improve()"
    [disabled]="!canImprove"
    [ngbTooltip]="improveTooltip"
    data-testid="btn-improve-prompt"
  >
    <i class="fa" [class.fa-magic]="!isImproving" [class.fa-spinner]="isImproving" [class.fa-spin]="isImproving"></i>
    {{ isImproving ? 'Melhorando...' : 'Melhorar com IA' }}
  </button>

  <button
    *ngIf="showRestore"
    type="button"
    class="prompt-action restore"
    (click)="restore()"
    [disabled]="isRestoring"
    ngbTooltip="Volta ao texto padrão do sistema. Só vale depois de salvar."
    data-testid="btn-restore-prompt"
  >
    <i class="fa" [class.fa-undo]="!isRestoring" [class.fa-spinner]="isRestoring" [class.fa-spin]="isRestoring"></i>
    Restaurar padrão
  </button>
</div>
